import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-1_vaHV5ILNP",
  ClientId: "63pakaojn82j6n96pmoshgl7n1",
};

export default new CognitoUserPool(poolData);
